<template>
  <div class="animated revealUp">
    <div class="white-wrapper">
      <div class="section-title">Traffic Analysis Flow</div>
      <div class="mt-3 mb-2">
        <div class="row">
          <div class="col-lg-6 col-xl-4 align-self-center mb-3">
            <div class="dropdown-curve-container">
              <label
                :class="
                  dropDown.cinemas && dropDown.cinemas.length > 0
                    ? 'shift-up'
                    : ''
                "
                >{{ $t("select") }} {{ $tc("cinema", 1) }}</label
              >
              <multiselect
                :disabled="isRoleID"
                :options="dropDown.cinemas"
                v-model="dropDown.selectedCinema"
                :searchable="true"
                label="cine_name"
                track-by="cine_id"
                placeholder="Select Cinema"
                @input="onSelectCinema($event)"
                :allowEmpty="false"
                :showLabels="false"
              ></multiselect>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="fromDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  type="date"
                  ref="programaticOpen"
                  v-model="fromDate"
                  v-validate="'required'"
                  @selected = "onChangeDate($event, 'from')"
                ></Datepicker>
                <label :class="fromDate ? 'active' : ''">
                  <!-- {{ $t("show") }} -->
                  {{ $t("fromdate") }}
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-xl-3 align-self-center mb-3">
            <div class="input-material">
              <div class="add-datepicker">
                <!-- <button class="btn-clearDate" v-if="toDate">
                  ✖
                </button> -->
                <Datepicker
                  :monday-first="true"
                  ref="programaticOpen"
                  v-model="toDate"
                  v-validate="'required'"
                >
                </Datepicker>
                <label :class="toDate ? 'active' : ''">
                  <!-- {{ $t("show") }}  -->
                  {{ $t("todate") }}</label
                >
              </div>
            </div>
          </div>

          <div class="col-lg-6 col-xl-2 align-self-center mb-3">
            <button
              class="btn-blue-lg w-100"
              @click.prevent="getTrafficAnalysisReport('N', 'N')"
            >
              {{ $t("fetch") }}
              {{ $t("report") }}
            </button>
          </div>

          <div
            v-if="trafficFlowRecords.length > 0"
            class="mr-3 w-100 align-self-center mb-3 d-flex justify-content-end align-items-center"
          >
            <div class="mx-1">{{ $t("download") }} as:</div>
            <!-- s -->

            <a
              target="_blank"
              @click="getTrafficAnalysisReport('Y', 'N')"
              title="Download as Excel"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/excel.svg"
                height="25"
                width="25"
              />
            </a>
            <a
              target="_blank"
              @click="getTrafficAnalysisReport('N', 'Y')"
              title="Download as PDF"
              download
            >
              <img
                class="mx-1"
                src="@/assets/img/icons/pdf.svg"
                height="25"
                width="25"
              />
            </a>
          </div>
        </div>
      </div>
      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
      >
        <table class="swc-report-table" border="1">
          <thead>
            <tr class="bg-lightgrey">
              <td rowspan="2">Hourly Analysis</td>
              <td
                class="border-bottom-0"
                colspan="5"
                v-for="(item, index) in weekDayArray"
                :key="index"
              >
                {{ item }}
              </td>
              <td class="border-bottom-0" colspan="5">Total</td>
            </tr>
            <tr class="bg-lightgrey">
              <template v-for="days in weekDayArray">
                <td class="bottom-left-border">Admits</td>
                <td class="bottom-border">%</td>
                <td class="bottom-border">Cum.</td>
                <td class="bottom-border">ConSales.</td>
                <td class="bottom-right-border">SPH.</td>
              </template>
              <td class="bottom-left-border">Admits</td>
              <td class="bottom-border">%</td>
              <td class="bottom-border">Cum.</td>
              <td class="bottom-border">ConSales.</td>
              <td class="bottom-right-border">SPH.</td>
            </tr>
          </thead>

          <tbody v-if="trafficFlowRecords.length > 0">
            <tr
              v-for="(data, dataIndex) in trafficFlowRecords"
              :key="dataIndex"
            >
              <td class="left-right-border">
                {{ data.start_time }}-{{ data.end_time }}
              </td>
              <template v-for="days in weekDayArray">
                <td class="border-0">{{ data[consVar.admits + days] }}</td>
                <td class="border-0">
                  {{ parseFloat(data[consVar.percent + days]).toFixed(2) }}
                </td>
                <td class="border-0">
                  {{ data[consVar.cum + days] }}
                </td>
                <td class="border-0">
                  {{ data[consVar.con_sales + days] }}
                </td>
                <td class="right-border">
                  {{ parseFloat(data[consVar.sph + days]).toFixed(2) }}
                </td>
              </template>
              <td class="border-0">{{ data[consVar.total] }}</td>
              <td class="border-0">
                {{ parseFloat(data[consVar.total_per]).toFixed(2) }}
              </td>
              <td class="border-0">
                {{ data[consVar.total_cum] }}
              </td>
              <td class="border-0">
                {{ data[consVar.total_concession] }}
              </td>
              <td class="right-border">
                {{ parseFloat(data[consVar.total_sph]).toFixed(2) }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td></td>
              <template v-for="days in weekDayArray">
                <td class="border-right-0">
                  {{ grandTotalOverall[consVar.admits + days] }}
                </td>
                <td class="top-bottom-border">
                  <!-- {{ parseFloat(grandTotalOverall[consVar.percent + days]) }} -->
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalOverall[consVar.cum + days] }}
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalOverall[consVar.con_sales + days] }}
                </td>
                <td class="border-left-0">
                  <!-- {{ grandTotalOverall[consVar. + days] }} -->
                </td>
              </template>
              <td class="border-right-0">
                {{ grandTotalOverall[consVar.total] }}
              </td>
              <td class="top-bottom-border">
                <!-- {{ parseFloat(grandTotalOverall[consVar.total_per]) }} -->
              </td>
              <td class="top-bottom-border">
                {{ grandTotalOverall[consVar.total_cum] }}
              </td>
              <td class="top-bottom-border">
                {{ grandTotalOverall[consVar.total_concession] }}
              </td>
              <td class="border-left-0">
                <!-- {{ grandTotalOverall[consVar.total_cum] }} -->
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="41">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
        class="my-2"
      >
        <table class="swc-report-table" border="1">
          <thead>
            <tr class="bg-lightgrey">
              <td rowspan="2">Timezones</td>
              <td
                ckass="border-bottom-0"
                colspan="5"
                v-for="(item, index) in weekDayArray"
                :key="index"
              >
                {{ item }}
              </td>
              <td class="bottom-right-border" colspan="5">Total</td>
            </tr>
            <tr class="bg-lightgrey">
              <template v-for="days in weekDayArray">
                <td class="bottom-left-border">Admits</td>
                <td class="bottom-border">%</td>
                <td class="bottom-border">Cum.</td>
                <td class="bottom-border">ConSales.</td>
                <td class="bottom-right-border">SPH.</td>
              </template>
              <td class="bottom-left-border">Admits</td>
              <td class="bottom-border">%</td>
              <td class="bottom-border">Cum.</td>
              <td class="bottom-border">ConSales.</td>
              <td class="bottom-right-border">SPH.</td>
            </tr>
          </thead>

          <tbody v-if="dayArray.length > 0">
            <tr>
              <td class="left-border" colspan="1" style="font-weight: bold">
                Days
              </td>
              <td
                v-for="blankspace of Array.from({ length: 8 })"
                class="left-right-border"
                colspan="5"
              ></td>
            </tr>
            <tr v-for="(data, dataIndex) in dayArray" :key="dataIndex">
              <td class="left-right-border">
                {{ data.start_time }}-{{ data.end_time }}
              </td>
              <template v-for="days in weekDayArray">
                <td class="left-border">{{ data[consVar.admits + days] }}</td>
                <td class="border-0">
                  {{ parseFloat(data[consVar.percent + days]).toFixed(2) }}
                </td>
                <td class="border-0">
                  {{ data[consVar.cum + days] }}
                </td>
                <td class="border-0">
                  {{ data[consVar.con_sales + days] }}
                </td>
                <td class="right-border">
                  {{ parseFloat(data[consVar.sph + days]).toFixed(2) }}
                </td>
              </template>
              <td class="left-border">{{ data[consVar.total] }}</td>
              <td class="border-0">
                {{ parseFloat(data[consVar.total_per]).toFixed(2) }}
              </td>
              <td class="border-0">
                {{ data[consVar.total_cum] }}
              </td>
              <td class="border-0">
                {{ data[consVar.total_concession] }}
              </td>
              <td class="right-border">
                {{ parseFloat(data[consVar.total_sph]).toFixed(2) }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td></td>
              <template v-for="days in weekDayArray">
                <td class="border-right-0">
                  {{ grandTotalDay[consVar.admits + days] }}
                </td>
                <td class="top-bottom-border">
                  <!-- {{ parseFloat(grandTotalDay[consVar.percent + days]) }} -->
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalDay[consVar.cum + days] }}
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalDay[consVar.con_sales + days] }}
                </td>
                <td class="border-left-0">
                  <!-- {{ grandTotalOverall[consVar. + days] }} -->
                </td>
              </template>
              <td class="border-right-0">{{ grandTotalDay[consVar.total] }}</td>
              <td class="top-bottom-border">
                <!-- {{ parseFloat(grandTotalDay[consVar.total_per]) }} -->
              </td>
              <td class="top-bottom-border">
                {{ grandTotalDay[consVar.total_cum] }}
              </td>
              <td class="top-bottom-border">
                {{ grandTotalDay[consVar.total_concession] }}
              </td>
              <td class="border-left-0">
                <!-- {{ grandTotalOverall[consVar.total_cum] }} -->
              </td>
            </tr>
          </tbody>
          <tbody v-if="nightArray.length > 0">
            <tr>
              <td class="left-border" colspan="1" style="font-weight: bold">
                Night
              </td>
              <td
                v-for="blankspace of Array.from({ length: 8 })"
                class="left-right-border"
                colspan="5"
              ></td>
            </tr>
            <tr v-for="(data, dataIndex) in nightArray" :key="dataIndex">
              <td class="left-right-border">
                {{ data.start_time }}-{{ data.end_time }}
              </td>
              <template v-for="days in weekDayArray">
                <td class="left-border">{{ data[consVar.admits + days] }}</td>
                <td class="border-0">
                  {{ parseFloat(data[consVar.percent + days]).toFixed(2) }}
                </td>
                <td class="border-0">
                  {{ data[consVar.cum + days] }}
                </td>
                <td class="border-0">
                  {{ data[consVar.con_sales + days] }}
                </td>
                <td class="right-border">
                  {{ parseFloat(data[consVar.sph + days]).toFixed(2) }}
                </td>
              </template>
              <td class="left-border">{{ data[consVar.total] }}</td>
              <td class="border-0">
                {{ parseFloat(data[consVar.total_per]).toFixed(2) }}
              </td>
              <td class="border-0">
                {{ data[consVar.total_cum] }}
              </td>
              <td class="border-0">
                {{ data[consVar.total_concession] }}
              </td>
              <td class="right-border">
                {{ parseFloat(data[consVar.total_sph]).toFixed(2) }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td></td>
              <template v-for="days in weekDayArray">
                <td class="border-right-0">
                  {{ grandTotalNight[consVar.admits + days] }}
                </td>
                <td class="top-bottom-border">
                  <!-- {{ parseFloat(grandTotalNight[consVar.percent + days]) }} -->
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalNight[consVar.cum + days] }}
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalNight[consVar.con_sales + days] }}
                </td>
                <td class="border-left-0">
                  <!-- {{ grandTotalOverall[consVar. + days] }} -->
                </td>
              </template>
              <td class="border-right-0">
                {{ grandTotalNight[consVar.total] }}
              </td>
              <td class="top-bottom-border">
                <!-- {{ parseFloat(grandTotalNight[consVar.total_per]) }} -->
              </td>
              <td class="top-bottom-border">
                {{ grandTotalNight[consVar.total_cum] }}
              </td>
              <td class="top-bottom-border">
                {{ grandTotalNight[consVar.total_concession] }}
              </td>
              <td class="border-left-0">
                <!-- {{ grandTotalOverall[consVar.total_cum] }} -->
              </td>
            </tr>
            <tr>
              <td colspan="41"></td>
            </tr>
            <tr class="bg-lightgrey">
              <td>Total</td>
              <template v-for="days in weekDayArray">
                <td class="border-right-0">
                  {{ grandTotalOverall[consVar.admits + days] }}
                </td>
                <td class="top-bottom-border">
                  <!-- {{ parseFloat(grandTotalOverall[consVar.percent + days]) }} -->
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalOverall[consVar.cum + days] }}
                </td>
                <td class="top-bottom-border">
                  {{ grandTotalOverall[consVar.con_sales + days] }}
                </td>
                <td class="border-left-0">
                  <!-- {{ grandTotalOverall[consVar. + days] }} -->
                </td>
              </template>
              <td class="border-right-0">
                {{ grandTotalOverall[consVar.total] }}
              </td>
              <td class="top-bottom-border">
                <!-- {{ parseFloat(grandTotalOverall[consVar.total_per]) }} -->
              </td>
              <td class="top-bottom-border">
                {{ grandTotalOverall[consVar.total_cum] }}
              </td>
              <td class="top-bottom-border">
                {{ grandTotalOverall[consVar.total_concession] }}
              </td>
              <td class="border-left-0">
                <!-- {{ grandTotalOverall[consVar.total_cum] }} -->
              </td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="25">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>

      <div
        style="overflow-x: scroll; width: auto !important"
        ref="exportable_table"
        class="my-2"
      >
        <table class="swc-report-table" border="1">
          <thead>
            <tr class="bg-lightgrey">
              <td>Percentages</td>
              <td class="" v-for="(item, index) in weekDayArray" :key="index">
                {{ item }}
              </td>
              <td>Total</td>
            </tr>
          </thead>

          <tbody v-if="arrayPercentage.length > 0">
            <tr
              v-for="(data, dataIndex) in arrayPercentage"
              :key="dataIndex"
              :class="dataIndex == 2 ? 'bg-lightgrey' : ''"
            >
              <td class="left-right-border">{{ data.key }}</td>
              <template v-for="days in weekDayArray">
                <td class="left-right-border">
                  {{ parseFloat(data[consVar.percent + days]).toFixed(2) }}
                </td>
              </template>
              <td class="right-border">
                {{ parseFloat(data[consVar.total]).toFixed(2) }}
              </td>
            </tr>
            <tr class="bg-lightgrey">
              <td class="border-right-0">Weekends</td>
              <td class="top-bottom-border">
                {{ parseFloat(objWeekDaysSales.weekendTotal).toFixed(2) }}
              </td>
              <td class="border-left-0"></td>
              <td class="border-right-0">Week Days</td>
              <td class="top-bottom-border">
                {{ parseFloat(objWeekDaysSales.weekdayTotal).toFixed(2) }}
              </td>
              <td class="border-left-0"></td>
              <td class="border-right-0">Week Nights</td>
              <td class="top-bottom-border">
                {{ parseFloat(objWeekDaysSales.weekNightTotal).toFixed(2) }}
              </td>
              <td class="border-left-0"></td>
            </tr>
          </tbody>
          <tbody v-else>
            <tr>
              <td colspan="25">
                <NoRecords />
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>
<script>
import { BASEURL } from "@/config/index";
import MasterService from "@/services/MasterService";
import ReportsService from "@/services/NewReportService";
import moment from "moment";
import NoRecords from "@/components/Partials/NoRecords.vue";

import VueHtml2pdf from "vue-html2pdf";
import * as XLSX from "xlsx";

export default {
  components: {
    NoRecords,
    VueHtml2pdf,
  },
  data() {
    return {
      BASEURL,
      isRoleID: false,
      submitted: false,
      dropDown: {
        cinemas: [],
        selectedCinema: null,
        selectedCinemaName: null,
        selectedCinemaId: "",
      },
      fromDate: new Date(),
      toDate: new Date(),
      trafficFlowRecords: [],
      excelFilePath: "",
      grandTotal: {},
      weekDayArray: [
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
        "Sunday",
      ],
      consVar: {},
      grandTotalOverall: {},
      grandTotalDay: {},
      grandTotalNight: {},
      dayArray: [],
      nightArray: [],
      arrayPercentage: [],
      objWeekDaysSales: {},
    };
  },
  beforeMount() {
    let CinemaObj = this.$store.getters.getSelectedDropDownCinema;
    const { cinema_id } = this.secureStore.get("USINFO");
    this.getCinemaList(cinema_id);
    // if (CinemaObj) {
    //   this.onSelectCinema(CinemaObj);
    // }
  },
  watch: {
    // "$store.getters.getSelectedDropDownCinema": function(CinemaObj) {
    //   if (CinemaObj) {
    //     this.onSelectCinema(CinemaObj);
    //   }
    // },
    excelFilePath(value) {
      this.excelFilePath = value;
    },
  },
  mounted() {},
  methods: {
    moment,
    onChangeDate(e, type){
      if(type == 'from'){
        this.toDate = new Date(e);
        this.$forceUpdate();
      }
    },
    ExportExcel(type, fn, dl) {
      var elt = this.$refs.exportable_table;
      var wb = XLSX.utils.table_to_book(elt, {
        sheet: `RawMaterialSupplierWise`,
      });
      return dl
        ? XLSX.write(wb, { bookType: type, bookSST: true, type: "base64" })
        : XLSX.writeFile(
            wb,
            fn ||
              `RawMaterialSupplierWiseCost-${
                this.dropDown.selectedCinemaName
              }.${type || "xlsx"}`
          );
    },
    getCinemaList: function (cinema_id) {
      MasterService.GetCinemas({cine_id: cinema_id})
        .then((response) => {
          const { data } = response;
          if (data.status && data.Records.length > 0) {
            this.dropDown.cinemas = data.Records;
            this.CinemasCopy = data.Records;
            if (data.Records.length == 1) {
              this.onSelectCinema(data.Records[0]);
              this.getTrafficAnalysisReport();
            }
          } else {
            this.$toasted.show(data.message);
          }
        })
        .catch(this._CatchError);
    },
    onSelectCinema: function (event) {
      this.dropDown.selectedCinema = event;
      this.dropDown.selectedCinemaName = event.cine_name;
      this.dropDown.selectedCinemaId = event.cine_id;
      this.$store.dispatch("selectDropdownCinema", event);
    },
    getTrafficAnalysisReport(isExcel = "N", isPdf = "N") {
      this.consVar = {};
      this.trafficFlowRecords = [];
      this.dayArray = [];
      this.grandTotalOverall = {};
      this.grandTotalDay = {};
      this.nightArray = [];
      this.arrayPercentage = [];
      this.grandTotalNight = {};
      this.objWeekDaysSales = {};
      if (!this.dropDown.selectedCinemaId) {
        return this.$toasted.show("Select Cinema");
      }
      if (!this.fromDate) {
        return this.$toasted.show("Select From Date");
      }
      let loader = this.$loading.show();
      let payload = {
        cinema_id: this.dropDown.selectedCinemaId,
        cinema_name: this.dropDown.selectedCinemaName || "",
        cinema_address: this.dropDown.selectedCinema.cine_address || "",
        fromDate: moment(this.fromDate).format("YYYY-MM-DD"),
        toDate: moment(this.toDate).format("YYYY-MM-DD"),
        isExcel,
        isPdf,
      };
      ReportsService.GetTraffcAnalysis(payload)
        .then((response) => {
          const { data } = response;
          this.consVar = {
            ...data.constantVariable,
          };
          this.weekDayArray = data.weekDay;
          this.grandTotalOverall = {
            ...data.grandTotalOverall,
          };
          this.grandTotalDay = {
            ...data.grandTotalDay,
          };
          this.grandTotalNight = {
            ...data.grandTotalNight,
          };
          this.objWeekDaysSales = {
            ...data.objWeekDaysSales,
          };
          if (data.status && data.Records.length > 0) {
            this.trafficFlowRecords = [...data.Records];
            this.dayArray = [...data.dayArray];
            this.nightArray = [...data.nightArray];
            this.arrayPercentage = [...data.arrayPercentage];

            // this.grandTotal = data.grandTotal;
            if (isExcel == "Y" && data.excelPath) {
              window.open(data.excelPath, "_blank");
            }
            if (isPdf == "Y" && data.pdfPath) {
              window.open(data.pdfPath, "_blank");
            }
            this.$toasted.show(data.message);
          } else {
            this.$toasted.show(data.message);
          }
          loader.hide();
        })
        .catch(this._CatchError)
        .finally(() => {
          setTimeout(() => {
            loader.hide();
          }, 100);
        });
    },
  },
};
</script>

<style scoped>
.left-border {
  border-left: 1px solid black !important;
  border-top: 0 !important;
  border-bottom: 0 !important;
  border-right: 0 !important;
}
.right-border {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 1px solid black !important;
  border-bottom: 0 !important;
}
.left-right-border {
  border-left: 1px solid black !important;
  border-top: 0 !important;
  border-right: 1px solid black !important;
  border-bottom: 0 !important;
}
.top-bottom-border {
  border-left: 0 !important;
  border-top: 1px solid black !important;
  border-right: 0 !important;
  border-bottom: 1px solid black !important;
}
.bottom-border {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 0 !important;
  border-bottom: 1px solid black !important;
}
.bottom-right-border {
  border-left: 0 !important;
  border-top: 0 !important;
  border-right: 1px solid black !important;
  border-bottom: 1px solid black !important;
}
.bottom-left-border {
  border-left: 1px solid black !important;
  border-top: 0 !important;
  border-right: 0;
  border-bottom: 1px solid black !important;
}

.concession-analysis-table {
  width: 100%;
  border: 1px solid #787878;
}

.concession-analysis-table thead {
  text-align: center;
  background-color: #dddedf;
}

.concession-analysis-table thead th {
  padding: 5px;
  border: 1px solid #000;
}

.concession-analysis-table tbody {
  border-bottom: 1px solid #000;
}

.concession-analysis-table tbody td {
  padding: 2.5px 5px;
  border-left: 1px solid #787878;
  border-right: 1px solid #787878;
}

.concession-analysis-table tbody td p {
  font-weight: bold;
  margin-bottom: 0;
}

.gcamp-tr td {
  width: 13%;
  border: 1px solid #000;
}

.swc-report-table {
  table-layout: auto !important;
  overflow-x: scroll !important;
  border: 1px solid black;
}

.swc-report-table td {
  white-space: nowrap;
}

.swc-report-table th {
  white-space: nowrap !important;
  border: 1px solid black !important;
}

.swc_table_header th {
  border: 1px solid black !important;
}
.borderOnly {
  border-left: 0px !important;
  border-top: 0px !important;
  border-bottom: 0px !important;
  border-right: 1px !important;
}

.no_border {
  border: 0px !important;
}
</style>



// WEBPACK FOOTER //
// src/components/Pages/ReportsContainer/trafficFlowAnalysis.vue